import _createForOfIteratorHelper from "E:/workspace/ysorder/order_admin_client/node_modules/@babel/runtime/helpers/esm/createForOfIteratorHelper.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.filter.js";
import "core-js/modules/es.iterator.for-each.js";
import "core-js/modules/es.iterator.map.js";
import "core-js/modules/es.json.stringify.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.replace.js";
import "core-js/modules/web.dom-collections.for-each.js";
import { upload } from '@/services/common';
import TinymceEditor from '@/components/tinymce';
import FooterToolBar from '@/components/tool/FooterToolBar';
import { getSEO, updateSEO } from '@/services/productDetail';
export default {
  name: 'pictureDescription',
  i18n: require('../i18n-productDetail'),
  components: {
    TinymceEditor: TinymceEditor,
    FooterToolBar: FooterToolBar
  },
  props: {
    productId: {
      type: Number,
      default: 0
    }
  },
  data: function data() {
    return {
      queryLoading: false,
      tabKey: 0,
      dataForm: {
        id: '',
        descList: []
      },
      previewVisible: false,
      previewImage: '',
      languageList: [],
      initDataForm: {
        id: '',
        descList: []
      },
      uploadLimit: 5,
      specList: [],
      defaultLangObj: {},
      specFlag: undefined,
      currentLink: '#public'
    };
  },
  mounted: function mounted() {
    var self = this;
    self.languageList = JSON.parse(localStorage.getItem('langList'));
    self.loadData();
    // this.$refs.public.scrollIntoView(true)
    console.log(self.$refs.public);
  },
  methods: {
    // changeUrl(link) {
    // 	console.log(link,'link')
    // 	this.currentLink = link
    // },
    // getCurrentAnchor() {
    // 	return this.currentLink
    // },
    clickAnchor: function clickAnchor(e) {
      e.preventDefault();
    },
    imgUpload: function imgUpload(blobInfo, success, failure) {
      console.log(111);
      var formData = new FormData();
      console.log(blobInfo);
      // formData.type= 6;
      formData.append('type', 6);
      formData.append('file', blobInfo.blob(), blobInfo.filename());
      upload(formData).then(function (res) {
        if (res.data.code == 200) {
          success(res.data.data.urlpath + res.data.data.uploadfilepath);
        }
      });
    },
    //富文本反转义html
    escape2Html: function escape2Html(str) {
      var arrEntities = {
        'lt': '<',
        'gt': '>',
        'nbsp': ' ',
        'amp': '&',
        'quot': '"'
      };
      return str.replace(/&(lt|gt|nbsp|amp|quot);/ig, function (all, t) {
        return arrEntities[t];
      });
    },
    loadData: function loadData() {
      var _this = this;
      var self = this;
      this.dataForm.id = this.productId;
      this.defaultLangObj = JSON.parse(localStorage.getItem('defaultLangObj'));
      var _iterator = _createForOfIteratorHelper(this.languageList),
        _step;
      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var item = _step.value;
          var nameObj = {};
          //多语言id
          nameObj.langId = item.langId;
          //名称
          nameObj.langName = item.langName;
          nameObj.productdesc = "";
          nameObj.speclist = [];
          if (item.langId == this.defaultLangObj.langId) {
            this.tabKey = nameObj.langId;
          }
          this.dataForm.descList.push(nameObj);
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
      if (this.productId > 0) {
        getSEO(this.dataForm.id).then(function (res) {
          var rs = res.data.data;
          _this.specFlag = res.data.data.specFlag;
          // if(this.specFlag !== 2) {
          // 	document.getElementById('dscPan').scrollIntoView({ behavior: "smooth"})
          // }
          // let rs = {"publiclist": [
          // 			{
          // 				"productdesc": "公共的信息",
          // 				"langId": 3
          // 			}
          // 		],
          // 		"specFlag": 1,
          // 		"speclist": [
          // 				{
          // 				"speclanglist":[
          // 					{
          // 						"productdesc": "规格值1",
          // 						"langId": 3  
          // 					}
          // 				],
          // 				"specvalue": "100g",
          // 				"specvalueId": 4104 
          // 			},
          // 				{
          // 				"speclanglist":[
          // 					{
          // 						"productdesc": "规格值2",
          // 						"langId": 3  
          // 					}
          // 				],
          // 				"specvalue": "200g",
          // 				"specvalueId": 4105 
          // 			},
          // 		]
          // 	}
          _this.specList = rs.speclist.map(function (item) {
            return {
              specvalue: item.specvalue,
              specvalueId: item.specvalueId
            };
          });
          console.log(_this.specList, '22222');
          _this.specList.unshift({
            specvalueId: 'public',
            specvalue: _this.$t('public.public')
          });
          // 公共的
          if (rs.publiclist.length > 0) {
            var _iterator2 = _createForOfIteratorHelper(_this.dataForm.descList),
              _step2;
            try {
              for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
                var item = _step2.value;
                var _iterator3 = _createForOfIteratorHelper(rs.publiclist),
                  _step3;
                try {
                  for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
                    var one = _step3.value;
                    if (item.langId == one.langId) {
                      item.productdesc = one.productdesc;
                      break;
                    }
                  }
                } catch (err) {
                  _iterator3.e(err);
                } finally {
                  _iterator3.f();
                }
              }
            } catch (err) {
              _iterator2.e(err);
            } finally {
              _iterator2.f();
            }
          }
          // 按照规格值的
          if (rs.speclist.length > 0) {
            // 循环语言
            var _iterator4 = _createForOfIteratorHelper(_this.dataForm.descList),
              _step4;
            try {
              var _loop = function _loop() {
                var item = _step4.value;
                // 循环规格值
                var _iterator5 = _createForOfIteratorHelper(rs.speclist),
                  _step5;
                try {
                  for (_iterator5.s(); !(_step5 = _iterator5.n()).done;) {
                    var item2 = _step5.value;
                    var specObj = {};
                    // 把与当前语言一样的keyword 提取出来
                    var nowDesc = item2.speclanglist.filter(function (item3) {
                      return item3.langId == item.langId;
                    });
                    specObj.productdesc = nowDesc.length > 0 ? nowDesc[0].productdesc : '';
                    specObj.specvalue = item2.specvalue;
                    specObj.specvalueId = item2.specvalueId;
                    item.speclist.push(specObj);
                  }
                } catch (err) {
                  _iterator5.e(err);
                } finally {
                  _iterator5.f();
                }
              };
              for (_iterator4.s(); !(_step4 = _iterator4.n()).done;) {
                _loop();
              }
            } catch (err) {
              _iterator4.e(err);
            } finally {
              _iterator4.f();
            }
          }
          //切换tab验证用
          self.initDataForm = _.cloneDeep(self.dataForm);
        });
      }
      console.log(self.$refs.public);
    },
    tabChange: function tabChange(activeKey) {
      //tabs 切换事件
      var self = this;
      self.tabKey = activeKey;
    },
    /* 确定添加 */save: function save() {
      var self = this;
      self.queryLoading = true;
      var newData = _.cloneDeep(self.dataForm);
      var newSpeclist = [];
      // 为了分规格值来存
      var falseKeywordlist = [];
      var falsespecId = [];
      var specLen = newData.descList[0].speclist.length;
      if (specLen > 0) {
        for (var i = 0; i < specLen; i++) {
          falseKeywordlist.push([]);
          falsespecId.push('');
        }
        // 外层循环是语言的循环
        newData.descList.forEach(function (item) {
          // 内层循环是规格的循环
          item.speclist.forEach(function (item2, index) {
            var newSpecobj = {
              specvalueId: '',
              speclanglist: []
            };
            // 根据规格值来赋值 这样不同规格值内容不一样
            falsespecId[index] = item2.specvalueId;
            newSpecobj.specvalueId = falsespecId[index];
            // 将这个规格值对应的多语言的keyword添加进去 falseKeywordlist再最外面 所以能保证拿到所有语言的keyword
            falseKeywordlist[index].push({
              langId: item.langId,
              productdesc: item2.productdesc
            });
            newSpecobj.speclanglist = falseKeywordlist[index];
            newSpeclist[index] = newSpecobj;
          });
        });
      }
      var params = {
        id: newData.id,
        publicList: newData.descList.map(function (item) {
          return {
            langId: item.langId,
            productdesc: item.productdesc
          };
        }),
        speclist: newSpeclist
      };
      console.log(params, 'params............');
      //  转化传参的格式

      updateSEO(params).then(function (result) {
        if (result.data.code == 200) {
          self.initDataForm = _.cloneDeep(self.dataForm);
          self.$message.success(self.$t('public.saveSuccessfully'));
        }
        self.queryLoading = false;
      }).finally(function () {
        self.queryLoading = false;
      });
    },
    check: function check() {
      if (JSON.stringify(this.initDataForm) != JSON.stringify(this.dataForm)) {
        return false;
      } else {
        return true;
      }
    }
  }
};